import {
  ContainerIcon,
  ContainerLogo,
  HeaderSidebar,
  LogoImg,
  LogoImg2,
} from "../style/style";
import { IconButton } from "@mui/material";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

export const HeaderSidebarComponent = (props: {
  bgColorHeader?: string;
  isHidden?: boolean;
  logoHeader?: string;
  hideDrawer?: () => void;
  iconHeader?: string;
}) => {
  return (
    <HeaderSidebar
      bgColorHeader={props.bgColorHeader}
      isHidden={props.isHidden}
    >
      <ContainerLogo isHidden={props.isHidden}>
        <LogoImg src={props.logoHeader} alt={"logo"} />
      </ContainerLogo>
      {!props.isHidden ? (
        <IconButton onClick={props.hideDrawer} disableRipple={true}>
          <UnfoldMoreIcon fontSize={"small"} sx={{ color: "#ffffff" }} />
        </IconButton>
      ) : (
        <ContainerIcon onClick={props.hideDrawer}>
          <LogoImg2 src={props.logoHeader} alt={"logo"} />
        </ContainerIcon>
      )}
    </HeaderSidebar>
  );
};
